import History from '@pages/gamers/history/history';
export default History;
